export default "__VITE_ASSET__Bb4_v2Vf__"